import styled from 'styled-components/macro';
import * as colors from '../../../../../../../../../../common/colorConstants';

export const InputQuantity = styled.input.attrs({ type: 'number' })`
  width: 64px;
  padding: 5px 12px;
  margin-right: 24px;
  margin-left: auto;
  font-size: 11px;
  line-height: 16px;
  color: ${colors.black4};
  outline: none;
  border: 1px solid ${colors.lightGray21};
  border-radius: 3px;
  font-weight: 700;

  &:disabled {
    color: ${colors.lightGray2};
    background-color: ${colors.lightGray14};
  }
`;
